import { WritingBadge } from './WritingBadge';
import { BadgeId, BadgesStats } from '../Models';

export default class YodaBadge extends WritingBadge {
  public readonly id = BadgeId.yoda;

  public evaluateIfAchieved = (stats: BadgesStats) => {
    return stats.pagesCount >= 44;
  };
}



// WEBPACK FOOTER //
// ./src/containers/Badges/AllBadges/yoda.ts